import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';

import colors from '../../../styles/colors';

const ActionButtonContainer = styled.div`
  display: ${({ $showOnHover }) => ($showOnHover ? 'none' : 'flex')};
  flex-direction: row;
  gap: 5px;
`;

const StyledLink = styled(Link)`
  color: ${colors.shades.secondary8};
  font-size: 16px;
  font-weight: 700;
  text-wrap: nowrap;
  width: 100%;
  overflow: hidden;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  .user-name {
    text-decoration: none;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
  width: 100%;
  padding: 0;

  &:hover > ${ActionButtonContainer} {
    display: flex;
  }
`;

const SubTitle = styled(Typography)`
  width: 100%;
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
  color: ${colors.shades.secondary3};
`;

const SubLine = styled(Typography)`
  width: 100%;
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
  margin-top: 4px;
  color: ${colors.shades.danger1};
`;

const StyledChatButtonContainer = styled.div`
  button {
    background-color: ${colors.base.gamma};
    border: 0.5px solid ${colors.shades.gamma1};
    svg {
      > path {
        stroke: ${colors.shades.secondary8};
        fill: ${colors.base.primary};
      }
    }
    &:hover {
      border: 0.5px solid ${colors.shades.gamma3};
    }
  }
`;

const StyledSecondaryProfileActionContainer = styled.div`
  button {
    border: 0.5px solid ${colors.shades.gamma1};
    background-color: ${colors.base.gamma};
  }
`;

export {
  Container,
  ActionButtonContainer,
  StyledLink,
  TextContainer,
  SubTitle,
  SubLine,
  StyledChatButtonContainer,
  StyledSecondaryProfileActionContainer,
};
